import { Fragment, useEffect, useRef, useState } from "react";
import { PermissionService } from "./PermissionService";
import { TreeTable } from "primereact/treetable";
import { Column } from "primereact/column";
import TreeNode from "primereact/treenode";
import { Checkbox } from "primereact/checkbox";
import { useToolbar } from "../../../shared/hooks/Toolbar";
import { PermissionService as Service } from "./PermissionService";
import { useDialogCrup } from "../../../shared/hooks/DialogCrup";
import { CONSTANT } from "../../../Constant";
import { useTranslation } from "../../../shared/language";

export const List = () => {
  const { t } = useTranslation();
  const dataKey = "name";
  const header = t('system.permissions');
  const ROOT_NODE_NAME = CONSTANT.ROOT_NODE_NAME;
  const nodes = useRef([]);
  const [expandedKeys, setExpandedKeys] = useState({});
  const [selectedNodeKey, setSelectedNodeKey] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    reloadLazyData();
  }, []);

  const getTreeRecur = (data: RoleNode[], parentNode: TreeNode) => {
    let childs = data
      .filter((t) => t.parentName == parentNode.key)
      .map((item) => {
        let data: TreeNode = {
          key: item.name,
          label: item.displayName,
          data: item,
          children: [],
        };
        return data;
      });

    parentNode.children = childs;
    if (childs.length) {
      childs.forEach((element) => {
        getTreeRecur(data, element);
      });
    }
  };

  const body = (rowData) => {
    return <Checkbox checked={rowData.data.isTenantDefault}></Checkbox>;
  };

  const reloadLazyData = () => {
    setSelectedNodeKey(null);
    setSelectedItems([]);
    
    PermissionService.systemPermission().then(async (res) => {
      nodes.current = [];
      let root: TreeNode = {
        key: ROOT_NODE_NAME,
        label: ROOT_NODE_NAME,
        data: ROOT_NODE_NAME,
        children: [],
      };
      await getTreeRecur(res, root);
      nodes.current = root.children;
      setExpandedKeys({});
    });
  };

  const selectItem = (value) => {
    setSelectedNodeKey(value.value);
  };

  const { render: renderDialogCrup, update } = useDialogCrup({
    header,
    dataKey,
    width: "60rem",
    fields: [{ field: "urlHelp", header: t('system.helpUrl'), required: false, InputTextProps: { maxLength: 400 }, className: "md:col-12" }],
    updateItem: (id, item) => {
      let isTenantDefault = selectedItems[0].isTenantDefault;
      item = { ...item, isTenantDefault };
      return Service.updatePermission(id, item);
    },
    // reloadLazyData
  });

  const onSelect = (event) => {
    let data = event.node.data;
    setSelectedItems([data]);
  };

  const onUnselect = (event) => {
    setSelectedItems([]);
  };

  const { renderToolbar } = useToolbar({
    dataKey,
    update: update,
    reloadLazyData,
    selectedItems,
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDialogCrup()}
      <div>
        <TreeTable
          value={nodes.current}
          expandedKeys={expandedKeys}
          onToggle={(e) => setExpandedKeys(e.value)}
          style={{ marginTop: ".5em" }}
          selectionMode="single"
          selectionKeys={selectedNodeKey}
          onSelectionChange={(e) => selectItem(e)}
          resizableColumns
          scrollHeight={`calc(100vh - ${240}px)`}
          scrollable
          showGridlines
          sortMode="multiple"
          className="small"
          onSelect={onSelect}
          onUnselect={onUnselect}
        >
          <Column field="displayName" header={t('common.entityName')} expander style={{ width: "50%" }} sortable></Column>
          <Column field="urlHelp" header={t('system.helpUrl')} style={{ width: "40%" }} sortable></Column>
          <Column
            field="isTenantDefault"
            header={t('system.default')}
            style={{ width: "10%" }}
            headerStyle={{ textAlign: "center" }}
            bodyStyle={{ textAlign: "center" }}
            body={body}
          ></Column>
        </TreeTable>
      </div>
    </Fragment>
  );
};

interface RoleNode {
  displayName: string;
  name: string;
  urlHelp: string;
  parentName: string;
  isTenantDefault: boolean;
  sortOrder?: number, 
  childs?: RoleNode[];
}
